<template>
  <section class="nav-scrolly-cats">
    <div class="nav-scrolly-cats-scroller">
      <ul v-if="useHardcodedData || topMenuCategories.length" class="nav-scrolly-cats-list">
        <li v-for="(item, index) of shopLinks" :key="index">
          <Link :href="item.url" @click="tagScrollyCatsLink(item.text)">
            {{ item.text }}
          </Link>
        </li>
      </ul>
      <div v-else class="nav-scrolly-cats-list scrolly-cats-loader">
        <Skeleton v-for="n in 12" :key="n" height="34px" width="80px" style="gap: 8px" />
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue';
import Link from '../common/Link';
import { useHamburgerTopMenu } from '~/composables/useHamburgerTopMenu';
import { tagScrollyCatsLink } from '#shared/features/analytics/scrollyCatsTags';
import Skeleton from '@nuxt-common/atomic-ui/app/components/skeleton/Skeleton';
import hardcodedShopLinks from '~/data/scrollyCats';

const props = defineProps({
  useHardcodedData: {
    type: Boolean,
    default: true,
  },
});

const { topMenuCategories } = useHamburgerTopMenu();
const shopLinks = computed(() => {
  if (props.useHardcodedData) {
    return hardcodedShopLinks;
  }

  return topMenuCategories.value.reduce((acc, cur) => {
    const { title = '', data } = cur;
    const isShopCategories = title.toLowerCase().includes('shop');

    if (isShopCategories) {
      data.forEach(({ text, url, children }) => {
        const shopAllItem = children?.find((item) => {
          if (!item.url) return false;

          const textLowerCased = item.text?.toLowerCase() || '';

          return textLowerCased.startsWith('shop all ') || textLowerCased.startsWith('all ');
        });

        if (shopAllItem) {
          acc.push({
            text,
            url: shopAllItem.url,
          });
        } else if (url) {
          acc.push({
            text,
            url,
          });
        }
      });
      return acc;
    }
    return acc;
  }, []);
});
</script>

<style lang="scss" brand="bcom">
$catsHeight: 34px;

.nav-scrolly-cats {
  white-space: nowrap;
  margin: 28px -16px -2px -16px;

  &-scroller {
    overflow-x: auto;
    scrollbar-width: none;
    -webkit-overflow-scrolling: touch;
    padding: 0 16px 2px 16px;
    display: flex;
  }

  &-list {
    display: flex;
    gap: 8px;

    & > div {
      flex-shrink: 0;
    }

    a {
      display: flex;
      text-decoration: none;
      align-items: center;
      justify-content: center;
      height: $catsHeight;
      min-width: 80px;
      padding: 0 8px;
      border: 1px solid #f1f1f1;
      box-shadow: 1px 1px 2px 0 rgba(0, 0, 0, 0.1);
      font-size: 13px;
    }
  }
}
</style>
